export default __webpack_public_path__ + "static/media/author-4.d70325ab.png";